import {useEffect} from "react";

export default function FormThanks(props){

    useEffect(()=>{
        window.disableHeightAdjustment = true;
    });

    return <div className={"p-12"}>
        <h1 className={"text-2xl text-white font-form"}>We’ve received your entry</h1>
        <hr className={"w-48 border-yellow-400 mt-2 mb-6 border-t-4"} />
        <h3 className={"text-xl text-white"}>You’ll get an email confirmation soon. Good Luck!</h3>
    </div>;
}
